import {http} from "@/plugins/axios"
import Convenio from "@/model/convenio"

function downloadDeclaracaoPdf(exercicio) {
    return http({
        url: `/declaracao/parcerias-interinstitucionais/pdf`,
        method: 'GET',
        params: { exercicio },
        responseType: 'blob',
    }).then((response) => {
        const blob = response.data;

        // Se a resposta não for PDF, pode ser um erro em JSON embrulhado como blob
        if (blob.type && blob.type !== 'application/pdf' && blob.type !== 'application/octet-stream') {
            return blob.text().then(text => {
                console.error('Resposta inesperada do servidor:', text);
                alert('Não foi possível gerar a declaração. Verifique se o exercício informado é válido.');
            });
        }

        const fileURL = window.URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
        const fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', `declaracao-parcerias-interinstitucionais-${exercicio}.pdf`);
        document.body.appendChild(fileLink);
        fileLink.click();
        document.body.removeChild(fileLink);
        // Revoga após 1s para garantir que o browser iniciou o download
        setTimeout(() => window.URL.revokeObjectURL(fileURL), 1000);
    }).catch((e) => {
        console.error('Erro ao baixar declaração:', e);
        alert('Erro ao baixar a declaração. Tente novamente.');
    });
}

function downloadArquivo(id) {
    return http({
        url: `/convenios/${id}/pdf`,
        method: 'GET',
        responseType: 'blob',
    }).then((response) => {
        const blob = response.data;
        const fileURL = window.URL.createObjectURL(new Blob([blob]));
        const fileLink = document.createElement('a');

        const header = response.headers['content-disposition'];
        const indexOfInicio = header ? header.indexOf('filename=') : -1;
        const filename = indexOfInicio >= 0
            ? header.slice(indexOfInicio + 9)
            : `convenio-${id}.pdf`;

        fileLink.href = fileURL;
        fileLink.setAttribute('download', filename);
        document.body.appendChild(fileLink);
        fileLink.click();
        document.body.removeChild(fileLink);
        // Revoga após 1s para garantir que o browser iniciou o download
        setTimeout(() => window.URL.revokeObjectURL(fileURL), 1000);
    }).catch((e) => {
        console.error('Erro ao baixar arquivo:', e);
    });
}

function buscarConvenio(id) {

    return http
        .get(`/convenios/${id}`)
        .then(res => Convenio(res.data))
        .catch((e) => {
            console.log(e);
        });
}

function buscarConvenioFiltro(filtro) {
    return http
        .get("/convenios/filtro", {
            params: {
                numeroProcesso: filtro.numeroProcesso,
                anoProcesso: filtro.anoProcesso,
                numeroParceria: filtro.numeroParceria,
                anoParceria: filtro.anoParceria,
                tipoConvenioId: filtro.tipoConvenioId,
                convenente: filtro.convenente,
                responsavel: filtro.responsavel,
            }
        })
        .then(res => res.data || [])
        .catch((err) => {
            // 404 = sem resultado (compatível com API antiga); qualquer outra falha
            // (rede, 5xx) é erro real: propaga para a tela mostrar o aviso de indisponibilidade
            if (err.response && err.response.status === 404) {
                return [];
            }
            throw err;
        });
}

function buscarTipoConvenio(id) {
    return http
        .get(`/tiposconvenio/${id}`)
        .then(res => res.data)
        .catch((e) => {
            console.log(e);
            return {tipoConvenioId: null, descricao: ""}
        });
}

function findTiposConvenio() {
    return http
        .get("/tiposconvenio")
        .then((response) => response.data)
        .catch((e) => {
            console.log(e);
        });
}

function salvar(convenio, arquivo) {

    var formData = new FormData();
    formData.append("convenio", JSON.stringify(convenio));

    if (arquivo != null) {
        formData.append("arquivo", arquivo)
    }
    if (convenio.convenioId == null) {
        //post
        return http
            .post("convenios/", formData)
            .then((res) => Convenio(res.data))
            .catch(err => console.error(err.message));

    } else { //put
        return http
            .put(`/convenios/${convenio.convenioId}`, formData)
            .then((res) => Convenio(res.data))
            .catch(err => console.error(err.message));
    }
}

function excluir(id) {
    return http
        .delete(`/convenios/${id}`)
        .then(res => {
            if (res.status === 204) {
                alert("Registro excluído com sucesso.")
                return "ok"
            }
        })
        .catch((e) => {
            console.log(e);
            alert("Não foi possivel excluir o item " + id);
            return "erro"
        });
}

function findAll() {
    return http
        .get("/convenios")
        .then((response) => response.data || [])
        .catch((e) => {
            console.error(e);
            throw e; // quem chama decide o que mostrar (aviso de indisponibilidade)
        });
}

let service = {}

service.findAll = findAll
service.salvar = salvar
service.excluir = excluir
service.findTiposConvenio = findTiposConvenio
service.buscarTipoConvenio = buscarTipoConvenio
service.buscarConvenioFiltro = buscarConvenioFiltro
service.buscarConvenio = buscarConvenio
//service.buscarDocumentoFiltro = buscarDocumentoFiltro
service.downloadArquivo = downloadArquivo
service.downloadDeclaracaoPdf = downloadDeclaracaoPdf

export default service